export default "__VITE_ASSET__Cm2gJI9r__"